const profileAppUrl = (env = "production") => {
  if (window.location.hostname == "localhost") return "http://localhost:8081";
  if (env == "staging") {
    return "https://profile.staging-community.ideasunited.com";
  }
  return "https://profile.community.ideasunited.com";
};
const adminToApi = () => {
  const redirectTo = {};
  redirectTo["http://localhost:8080"] = "http://localhost:8080";
  redirectTo["https://admin.community.ideasunited.com"] =
    "https://api-community.ideasunited.com";

  return redirectTo;
};

export { profileAppUrl, adminToApi };
